export const  SET_CATAGORIES = "SET_CATAGORIES"